module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/direct/icon_plus-7960a56786d6b949a38f719e98abf78a.svg";